const kur = {
  translation: {
    app_title: "قندیل بلباس",
    home1: "بۆ بازرگانی گشتی سنوردار",
    home2: "بۆ بازرگانی گشتی سنوردار",
    home3: "بۆ بازرگانی گشتی سنوردار",
    home4: "بۆ بازرگانی گشتی سنوردار",
    home: "سەرەتا",
    about: "دەربارە",
    services: "خزمەتگوزارییەکانمان",
    partners: "هاوبەشەکان",
    sanaPanel: "حیات پەنەڵ",
    powerPanel: " قوە پەنەڵ",
    power: "قوە",
    blackPipe: "بلاک پایپ",
    qandelBrc: "قەندیل BRC",
    alSmood: "صمود",
    products: "بەرهەمەکانی ئێمە",
    contact: "پەیوەندیمان پێوەبکە",
    about_us: "دەربارەی ئێمە",
    core:"توانا بنەڕەتییەکان و هاوبەشییەکانمان",
    targetp:"ئامانجی ئێمە ئەوەیە کە ببینە هاوبەشێکی باوەڕپێکراوی ناوچەیی و نێودەوڵەتی لە پشتگیریکردنی گەشەی شارستانی، گەشەپێدانی ژێرخان و فراوانبوونی پیشەسازیدا.",
    target1p:"کۆمپانیاکەمان پابەندە بە دروستکردنی هاوبەشی درێژخایەن لەگەڵ کڕیارانمان، بە دابینکردنی کوالیتی مسۆگەرکراو، نرخی کێبڕکێ و چارەسەری کرداری کە گونجاوە بۆ پێداویستییە تایبەتییەکانی هەر پڕۆژەیەک.",
    objectiv:"ئامانجەکانمان:",
    ob1:"فراوانکردنی ستراتیژی :  زیادکردنی پشکی بازاڕ لە ڕێگەی سوودوەرگرتن لە تۆڕی دابینکارانی ئێستامان لە تورکیا، میسر، ئیمارات و چین، بە مەبەستی ناساندنی هێڵی بەرهەمی نوێ بە بازاڕی ناوخۆیی.",
    ob2:"داهێنان لە بواری تەلارسازیدا: پێشەنگایەتی لە بەکارهێنانی پانێڵی جۆری (PIR Sandwich Panels) و شێوازە پێشکەوتووەکانی پۆڵا بۆ کەمکردنەوەی ماوەی جێبەجێکردنی پڕۆژەکان و باشترکردنی کوالێتی عەزلی گەرمی لە ژێرخانەکانی عێراقدا.",
    ob3:"نایابی لە جێبەجێکردندا : تێکەڵکردنی تەکنیکەکانی جێبەجێکردنی خێرا لەگەڵ شێوازەکانی بیناسازی بەردەوام، بەبێ سازشکردن لەسەر بنەما و پێوەرە توندەکانی سەلامەتیمان.",
    about_p: `هەر لەوکاتەی کۆمپانیاکەمان لە ساڵی ٢٠١٠ لە هەولێر دامەزراوە، ناوبانگێکی بەهێزی خۆی وەک پێشەنگ لە بواری بازرگانی و بەڵێندەرایەتی گشتی دروست کردووە، کە پسپۆڕ و شارەزایە لە بواری ئاسن، کەرەستەی بیناسازی، کەرەستە کیمیاییە پیشەسازییەکان و دابینکردنی چارەسەری ژێرخان. بەهۆی ئەزموونی ساڵانە و کارایی پتەوەوە، پێگەی خۆمان وەک هاوبەشێکی باوەڕپێکراو بۆ پڕۆژەکانی کەرتی گشتی و تایبەت جێگیر کردووە.
کۆمپانیاکەمان خاوەنی دابینکردنی تۆڕێکی پتەوی نێودەوڵەتی لەگەڵ بەرهەمهێنەر و دابینکەرە سەرەکییەکان لە وڵاتانی تورکیا، میسر، میرنشینە یەکگرتووە عەرەبییەکان، چین و بازاڕەکانی دیکەی جیهان. ئەم پەیوەندییانە ئەو توانایەمان پێدەبەخشێت کە بەرهەمی کوالێتی بەرز بە ستانداری نێودەوڵەتی و بەنرخی گونجاو و کێبەرکێکار پێشکەش بە کڕیارەکان بکەین، لە گەڵ مسۆگەری و دڵنيایی لە گەیاندن و دابینکردنی باوەڕپێکراو،و لە کاتی دیاریکراو.
`,
    pf:"کۆمپانیاکەمان کۆمەڵێکی فراوانی کەرەستە پێشکەش دەکات، لەوانە:",
    pf1:"ئاسن و بەرهەمەکانی",
    pf2:"سولە و بەشەکانی پۆڵایینی پێکهاتەی بيناکان.",
    pf3:"بی ئار سی BRC.",
    pf4:"کەرەستەی سەرەکی بیناسازی و دروستکردن.",
    pf5:"کەرەستەی کیمیاییە پیشەسازییەکان کە لە ژێرخان، نەوت و گاز و چەندین بەشی پیشەسازی تر بەکار دەهێنرێن ",
    pf6:"بازرگانی لەگەڵ کۆمپانیاکانی نەوت و دابینکردنی خزمەتگوزاری گواستنەوە و ئاسایش لەخۆدەگرێت.",
    aboutp1:"هەر لەگەڵ بواری بازرگانی، خزمەتگوزاری بەڵێندەرایەتی دابین دەکەین کە دابینکردن و جێبەجێکردنی پڕۆژە لەخۆدەگرێت، بە شێوەیەک کە هەر پڕۆژەیەک بەپێی بەرزترین پێوەرەکانی کوالیتی، کارامەیی و سەلامەتی ڕادەسپێردرێت.",
    aboutp2:"کۆمپانیاکەمان مۆڵەتی ئەنجامدانی کاری بازرگانی لەگەڵ ویلایەتە یەکگرتووەکانی ئەمریکا و لەناویشیدا وەرگرتووە، بەشێوەیەکی چالاکانە هاوبەشی ستراتیجی لەگەڵ کۆمپانیا ئەمریکییەکان دادەمەزرێنێت. ئەمەش توانای دابینکردن فراوان دەکات، دەستکەوتن بە تەکنەلۆژیای پێشکەوتوو دەستەبەر دەکات، و هاوکاری نێودەوڵەتی لە بوارەکانی گەشەپێدانی بیناسازی و پیشەسازیدا بەهێز دەکات.",
    why_chose_us: "بۆچی ئێمە؟",
    reason1: "متمانەی بازار.",
    reason2: "خێرای لە جێبەجی کردنی داواکاری تایبەت.",
    reason3: "شارەزای و ئەزموونی زیاتر لە ٣٠ ساڵ.",
    contact_form: "پەیوەندیمان پێوەبکە",
    name: "ناو",
    email: "ئیمەیڵ",
    message: "نامە",
    send_message: "ناردنی نامە",
    contact_p:
      "An Iraqi delivery company. Our goal is to give the best model for delivery companies by employing expertise and using the latest internationally approved technology.",
    address: "ناونیشان",
    address_value:
      "عێراق، هەولێر، شەقامی ڕوناکی، بەرامبەر نەخۆشخانەی چاوی وێست ئای، باڵەخانەی سەید طيب بەقال، نهۆمی حەفتەم",
    phone: "ژمارە مۆبایل",
    copy_right: "© مافی پارێزراوە بۆ کۆمپانیای قەندیل بلباس",
    page_not_found: "Page Not Found",
    is_required: "is required!",
    not_valid: "is not a valid email!",
    service1: "هێلی بڕینی پلێت",
    service1_p:
      "بۆ بڕینی پلێت بە درێژی بۆ هەموو جۆرەکانی پلێتی ڕەنگی و گەلفەنایزو ڕەشی سارد و گەرم.",
    service1_li1: "بەرینی پلێت : لە 40سم تا 150سم",
    service1_li2: "ئەستوری پلێت : لە 0.20ملم تا 2.00 ملم",
    service1_li3: "درێژی بڕین : لە 125سم تا 700سم",
    service2: "هێلی دروستکردنی کێربی",
    service2_p:
      "بۆ ئامادەکردنی کێربی بۆ داپۆشینی سەربانەکان و بنمیچی خانوو و کۆگا و گەراجەکان.",
    service2_li1: "بەرینی پلێتی بەکارهاتوو : 120سم ، 122سم ،125سم .",
    service2_li2: "بەرینی کێربی : 100سم تەواو.",
    service2_li3: "ەستوری پلێتی بەکارهاتوو : لە 0.20ملم تا 0.90 ملم",
    service2_li4: "درێژی کێربی : لە 125سم تا 1700سم",
    service4: "پیشەسازی نەوت",
    service4_p: `کۆمپانیای Setup Venture باشترین خزمەتگوزاری لۆجستی و تەکنیکی بۆ پڕۆژە نەوتییەکان دابین دەکات. ئێمە بە پابەندبوون بە ستانداردە جیهانییەکان، کارایی و سەلامەتی کارەکانتان گەرەنتی 
دەکەین.`,
    service5: "ئاسایش",
    service5_p: `ئێکسپات کۆمپاس چارەسەری سیکیوریتی گشتگیر بۆ پاراستنی مرۆڤ و سەرمایەکان دابین دەکات بە تێکەڵکردنی پاسەوانی فیزیایی و تەکنەلۆژی. ئێمە بە پشتەستن بە ٤٠ ساڵ ئەزموونی متمانەپێکراو لە عێراقدا، پاراستنی بێوێنە بۆ پڕۆژە گرنگەکانتان گەرەنتی دەکەین.`,
    view_pdf: "View Profile Catalog",
    s_top_header1: "كارگەی حيات پەنەڵ بۆ بەرهەمهێنانی سەندەویج پەنەڵ",
    service3: "مشاری بڕینی سارد",
    service3_p:
      "دابینکردن و تیژکردنەوە و چاککردنەوەی موشاری ساردی بڕین",
    
    s_about_p:
      "کارگەی حيات پەنەڵ كارگەيەكي خۆماڵيه، لەساڵی 2017 دامەزراوه و له ساڵی 2018 دا سەندەویچ پەنەڵی بەرهەمهێنا به هەردوو جۆری دیواری و بنمیچی، بەرهەمی سەندەویچ پەنەڵی پاوەرپەنەڵ بە ئامێری ئۆتۆماتیکی و کوالێتی بەرز و ستاندەری جیهانی و بەپێی داواکاری بەرهەم دەهێنرێن .ئامانجی کارگەی پاوەر پەنەڵ پەرەپێدان  ئاوەدانکردنەوە و گەشەپێدانی وڵاتەکەمانە بە بەرهەمێکی خۆماڵی و ڕەخساندنی هەلی کاری زیاتر بۆ هاوڵاتیانە.",
    s_whatspanel: "سەندویچ پەنەڵ چییە؟",
    s_whatspanel_p:
      "سەندویچ پەنەڵ بەرهەمێکە کێشی سوکە و لە سێ چین پێکدێت، بەوەش کۆمەڵێک توانا و تایبەتمەندی پێ دەبەخشێ، بەوەی نەگەیەنەرێکی باشە بۆ گەرمی و ساردی و دەنگ و هەروەها ئاسانی بەستان و بەکارهێنانی. لە نێوان دوو چینی دژە ژەنگی پلێتی سەرەوە و خوارەوە چینێک لە ماددەی پۆلی یۆریثین و پۆلیسترین دادەنرێت، ئەو ماددەیە چەند تایبەتمەندییەکی فیزیایی ناوازەی هەیە وەک بەرهەڵستی ئاگر و ساردی و گەرمی، بەوەش بەهای تێچووی بەکارهێنانی وزە کەم دەکاتەوە.",
    s_availables: "پێوانەو ئەستووری پەنەڵی بەرهەمهاتوو",
    s_specifics: "تایبەتمەندییەکان",
    s_spec_width: "پانی",
    s_spec_length: "درێژی",
    s_spec_thikness: "ئەستووری",
    s_spec_density: "چڕی",
    s_spec_thermal: "گەیاندنی گەرمی",
    s_spec_sound: "تێپەڕینی دەنگ",
    s_roof: "پەنەڵی بنمیچ",
    s_wall: "پەنەڵی دیوار",
    s_f_1: "1000 مم",
    s_f_2: "18 م ماکس",
    s_f_3: "50, 75, 100 مم",
    s_f_4: "40 کگم/م",
    s_f_4a: " (∓2)",
    s_f_5: "0.022 w/mk",
    s_f_6: "25 dB",
    s_application: "بەکارهێنانەکانی",
    s_application_p:
      "سەندوچ پەنەڵ لە زۆر بواردا بەکاردێت بەتایبەت لە بنیاتنانی پێشانگا و کۆگا و خانوو و کۆگاکانی ساردکەرەوە و چێشتخانە و هۆڵی وەرزشی و کێڵگەی پەلەوەر و قوتابخانە و شوێنی بازرگانی و فرۆکەخانە و هتد",
    s_type: "جۆری بەرهەمی کارگە",
    s_type1: "سەندەویچی جۆری Rigid Polyurethane (PUR)",
    s_type2: "سەندەویچی جۆری Polyisocyanurate (PIR)",
    s_type3: "Sandwich Panel Ridges",
    s_specification: "تایبەتمەندییەکانی سەندویچ پەنەڵ",
    s_specific_1: "دژە باران و هەڵم",
    s_specific_2: "دژە ژەنگ",
    s_specific_3: "بەرگری دژی ڕەشەبا و زریان",
    s_specific_4: "بەرگری دژی تیشکی خۆر",
    s_specific_5: "بەرگری دژی ماددە کیمیاییەکان",
    s_specific_6: "دژە ئاگر",
    s_specific_7: "دژەگەرمی",
    s_specific_8: "دژە دەنگ",
    s_specific_9: "دژە زەمینلەرزە و لەرینەوە",
    s_specific_10: "دژە مێروو",
    s_specific_11: "جوانی لە ڕواڵەت و رێکی لە ئەندازە",
    s_specific_12: "دۆستی ژینگە",
    s_specific_13: "نرخی کەم و خێرا لە بنیاتنان",
    s_specific_14: "ڕەنگی جۆراوجۆر",
    s_specific_15: "توندی پتەوی",
    s_specific_16: "توانای دووبارە بەکارهێنانەوە",
    s_add_value: "كەرکوك ، ڕێگای خێرای دەرەوەی شار، نزیك بەرزەپردی لەیلان",
    p_top_header1: "كارگەی قوە پەنەڵ بۆ بەرهەمهێنانی سەندەویج پەنەڵ",
    p_about_p:
      "کارگەی قوە پەنەڵ كارگەيەكي خۆماڵيه، لەساڵی 2017 دامەزراوه و له ساڵی 2018 دا سەندەویچ پەنەڵی بەرهەمهێنا به هەردوو جۆری دیواری و بنمیچی، بەرهەمی سەندەویچ پەنەڵی پاوەرپەنەڵ بە ئامێری ئۆتۆماتیکی و کوالێتی بەرز و ستاندەری جیهانی و بەپێی داواکاری بەرهەم دەهێنرێن .ئامانجی کارگەی پاوەر پەنەڵ پەرەپێدان  ئاوەدانکردنەوە و گەشەپێدانی وڵاتەکەمانە بە بەرهەمێکی خۆماڵی و ڕەخساندنی هەلی کاری زیاتر بۆ هاوڵاتیانە.",
    p_whatspanel: "سەندویچ پەنەڵ چییە؟",
    p_whatspanel_p:
      "سەندویچ پەنەڵ بەرهەمێکە کێشی سوکە و لە سێ چین پێکدێت، بەوەش کۆمەڵێک توانا و تایبەتمەندی پێ دەبەخشێ، بەوەی نەگەیەنەرێکی باشە بۆ گەرمی و ساردی و دەنگ و هەروەها ئاسانی بەستان و بەکارهێنانی. لە نێوان دوو چینی دژە ژەنگی پلێتی سەرەوە و خوارەوە چینێک لە ماددەی پۆلی یۆریثین و پۆلیسترین دادەنرێت، ئەو ماددەیە چەند تایبەتمەندییەکی فیزیایی ناوازەی هەیە وەک بەرهەڵستی ئاگر و ساردی و گەرمی، بەوەش بەهای تێچووی بەکارهێنانی وزە کەم دەکاتەوە.",
    p_availables: "پێوانەو ئەستووری پەنەڵی بەرهەمهاتوو",
    p_specifics: "تایبەتمەندییەکان",
    p_spec_width: "پانی",
    p_spec_length: "درێژی",
    p_spec_thikness: "ئەستووری",
    p_spec_density: "چڕی",
    p_spec_thermal: "گەیاندنی گەرمی",
    p_spec_sound: "تێپەڕینی دەنگ",
    p_roof: "پەنەڵی بنمیچ",
    p_wall: "پەنەڵی دیوار",
    p_f_1: "1000 مم",
    p_f_2: "18 م ماکس",
    p_f_3: "50, 75, 100 مم",
    p_f_4: "40 کگم/م",
    p_f_4a: " (∓2)",
    p_f_5: "0.022 w/mk",
    p_f_6: "25 dB",
    p_application: "بەکارهێنانەکانی",
    p_application_p:
      "سەندوچ پەنەڵ لە زۆر بواردا بەکاردێت بەتایبەت لە بنیاتنانی پێشانگا و کۆگا و خانوو و کۆگاکانی ساردکەرەوە و چێشتخانە و هۆڵی وەرزشی و کێڵگەی پەلەوەر و قوتابخانە و شوێنی بازرگانی و فرۆکەخانە و هتد",
    p_type: "جۆری بەرهەمی کارگە",
    p_type1: "سەندەویچی جۆری Rigid Polyurethane (PUR)",
    p_type2: "سەندەویچی جۆری Polyisocyanurate (PIR)",
    p_type3: "Sandwich Panel Ridges",
    p_specification: "تایبەتمەندییەکانی سەندویچ پەنەڵ",
    p_specific_1: "دژە باران و هەڵم",
    p_specific_2: "دژە ژەنگ",
    p_specific_3: "بەرگری دژی ڕەشەبا و زریان",
    p_specific_4: "بەرگری دژی تیشکی خۆر",
    p_specific_5: "بەرگری دژی ماددە کیمیاییەکان",
    p_specific_6: "دژە ئاگر",
    p_specific_7: "دژەگەرمی",
    p_specific_8: "دژە دەنگ",
    p_specific_9: "دژە زەمینلەرزە و لەرینەوە",
    p_specific_10: "دژە مێروو",
    p_specific_11: "جوانی لە ڕواڵەت و رێکی لە ئەندازە",
    p_specific_12: "دۆستی ژینگە",
    p_specific_13: "نرخی کەم و خێرا لە بنیاتنان",
    p_specific_14: "ڕەنگی جۆراوجۆر",
    p_specific_15: "توندی پتەوی",
    p_specific_16: "توانای دووبارە بەکارهێنانەوە",
    p_add_value: "دهوك ، زاخۆ ، حسن ئافا ، پشت پێشانگاکانی ئۆتۆمبیل",
    b_top_header1: "کارگەی بلاک پایپ بۆ بەرهەم هێنانی بۆری و پڕۆفایلی پۆڵا",
    b_about_p: " کارگـەی بـلاك پایـپ بـە ئامێـری نـوێ و پێشـکەوتوو و بەپێـی سـتانداری عێراقـی و جیهانـی و بەدەســتی ئەندازیارانــی کارامــە و خــاوەن ئەزمــوون، چاکتریــن بــۆڕی و پرۆفیلــی ئاســن بە پێوانەی جۆراوجۆر بەرهەم دەهێنێت. کارگەکەمــان لەســاڵی 2021 دامــەزراوە و لەماوەیەکــی کورتتــدا بەهــۆی بەرهەمەکانــی لە ڕووی چۆنیەتی و چەندیتیەوە پێگەی خۆی لەناو بازاڕدا جێگیرکرد. ئامانجــی کارگەکەمــان پشتبەســتنە بــە ئەندازیــاران و کارمەندانــی ناوەخــۆ و دابینکردنــی باشــترین جــۆری پرۆفیــل و بــۆڕی ئاســن، و دابینکردنــی داواکاریــەکان لەماوەیەکــی کورتتــدا بەشێوەیەك چیتر پێویستامن بە هاوردەکردنی بەرهەمی دەرەکی نەبێ.",
    b_type1: "پڕۆفیل و بۆڕی ڕەش (گەرم)",
    b_type2: "پڕۆفیل و بۆڕی ڕەش (سارد)",
    b_type3: "پڕۆفیل و بۆڕی گەلڤەنایز",
    b_di1:"بۆڕی خڕ (لوولەیی)",
    b_di2:"بۆڕی چوار گۆشەیی",
    b_di3:"بۆڕی لاکێشەیی",
    b_di4:"بۆڕی شێوە تایبەت",
     b_add_value: "عێراق، ھەولێر، ڕێگای گوێر، نزیک قەریتاغ",
     br_add_value: "ناونیشان: شاری فەللوجە – پارێزگای ئەنبار – عێراق ",

     
    brabout_p:"کارگەی قەندیل بە یەکێک لە نوێترین پڕۆژە پیشەسازییەکانی شاری فەللوجە دادەنرێت کە تایبەتە بە بەرهەمهێنانیBRC   .  ئێمە لە کارەکانماندا پشت بە هێڵە ئۆتۆماتیکییە پێشکەوتووەکان دەبەستین و باشترین جۆری خاوی ئاسن بەکاردەهێنین. ئامانجمان پێشکەشکردنی بەرهەمێکی باش و کوالێتی بەرزە کە لەگەڵ ستانداردە عێراقی و جیهانییەکاندا بگونجێت بۆ خزمەتکردنی کەرتی بیناسازی لە عێراق.  جێگای شانازیمانە کە پشکمان هەیە لە ئاوەدانکردنەوەی پارێزگای ئەنبار و گشت شارەکانی عێراق.",
    brdesc:"BRC چییە",
    brdesc_p:"BRC پێکهاتووە لە تۆڕێکی ئاسنین کە بە کارەبا لەحیمکراوە، لە کۆمەڵێك تەلێك لە باری درێژی و پانی پێکدێت کە بە گۆشەی وەستاو یەکتر دەبڕن. ئەم بەرهەمە باشترین جێگرەوەیە بۆ شیشی ئاسنی ئاسایی لە کارە کۆنکرێتییەکاندا، چونکە کات و ماندووبوون کەمدەکاتەوە و دابەشبوونی وردی ئاسنەکە مسۆگەر دەکات.",
    brad:"گرنگترین تایبەتمەندییەکانی:",
    brad1:"خێرایی لە جێبەجێکردندا: داپۆشینی ڕووبەرێکی زۆر لە کاتێکی کەمدا.",
    brad2:"لە پێوانەکاندا: هەبوونی بۆشایی ڕێک و یەکسان کە دابەشبوونی دروستی فشارەکان مسۆگەر دەکات.",
    brad3:"کەمکردنەوەی بەفیڕۆچوون: چونکە بە پێوانەی دیاریکراو دروست دەکرێت، پاشماوەی ئاسنی کەم دەبێتەوە.",
    brad4:"کوالێتی لەحیمکردن: لەحیمکردنی کارەبایی زۆر بەهێز کە جێگیری BRCیەکە لە کاتی کۆنکرێتکردندا دەپارێزێت.",
    brspe:"زانیارییە تەکنیکییەکانی بەرهەم ",
    brspep:"لە کارگەی قەندیل جۆرەها قەبارە بەرهەم دەهێنین بۆ پڕۆژەکانی نیشتەجێبوون، پیشەسازی و ژێرخان.",
    feature:"جۆری خزمەتگوزاری",
    specification:"وردەکارییەکان",
    ad:"تیرەی (قەبارە) تەلەکان",
    ad1:"لە ٣.٥٠ ملم تا ١٤ ملم",
    od:"قەبارەی بۆشاییەکان",
    od1:"لە ١٠٠×١٠٠ ملم تا ٢٥٠×٢٥٠ ملم",
    sd:"پێوانەی ستانداردی تەبەقەکان",
    sd1:"٢ × ٦ مەتر (دەکرێت بەپێی داواکاری بگۆڕدرێت))",
    ms:"شێوەی BRC",
    ms1:"چوارگۆشە یان لاکێشە بەپێی ویستی کڕیار",
    note_p:"تێبینی: دەتوانین تەبەقەکان بەپێی پێداویستی پڕۆژە و بەو درێژییەی کڕیار داوای دەکات دروست بکەین.",
    feilofap:"بوارەکانی بەکارهێنان ",
    foa1:"بناغە: بۆ بەهێزکردنی بناغە کۆنکرێتییەکان و ڕووەکان.",
    foa2:"بنمیچ و سەربان: وەک جێگرەوەیەکی خێرا و کارا بۆ شیشی تەقلیدی لە بنمیچ و سەربانەکاندا.",
    foa3:"ڕێگاوبان و پرد: بۆ بەهێزکردنی چینی ڕێگاکان و پردە کۆنکرێتییەکان.",
    foa4:"پارچە ئامادەکراوەکان: بەکارهێنانی لە کارگەکانی بلۆک، بۆری کۆنکرێتی و دیوارەکان.",
    foa5:"پەرژین: دروستکردنی BRC بە قەبارەی گونجاو بۆ پەرژین بەپێی داواکاری.",
    brwhy:"بۆچی کارگەی قەندیل هەڵدەبژێریت",
    brwhy1:"فرە ڕەهەندی لە بەرهەمهێناندا: دابینکردنی هەموو تیرەکانی تەل لە ٣.٥ ملم تا ١٤ ملم و هەموو قەبارەیەکی بۆشاییەکان.",
    brwhy2:"تەبەقەی ٦ مەتری: یارمەتیدەرە بۆ کەمکردنەوەی جومگەکان و خێراکردنی کار، لەگەڵ ئەگەری دروستکردنی درێژی تایبەت.",
    brwhy3:"کوالێتی بەرز: بەکارهێنانی ئاسنی بلیت و پشکنینی بەردەوام بۆ بەرگری و جێگیری لەحیمکردنەکان.",
    brwhy4:"تەکنەلۆژیای سەردەم: بەکارهێنانی سیستەمی دیجیتاڵی لە هێڵەکانی بەرهەمهێناندا بۆ لەحیمکردنی کارەبایی کوالێتی بەرز.",
    brwhy5:"توانای بەرهەمهێنانی زۆر: دابینکردنی پێداویستی پڕۆژە گەورەکان لە کاتێکی کەمدا.",
    brwhy6:"خزمەتگوزاری گەیاندن: خاوەنی ئۆتۆمبێلی تایبەتین بۆ گەیاندنی بار بۆ فەللوجە و هەموو شارەکانی تری عێراق.",
    quality:"کوالێتی و ستاندارد ",
    quality_p:"بەرهەمەکانمان بەپێی پێوەرە فەرمییەکانی عێراق (IQS) و جیهانین. پشکنینی خولی لە تاقیگە باوەڕپێکراوەکان ئەنجام دەدرێت بۆ دڵنیابوون لە وردی ڕەهەندەکان و جێگیری لەحیمکردنەکان.",
    br_top_header1:"کارگەی قەندیل بۆ بەرهەمهێنانی شیشی تۆکمەکراو",

    smabout_p:"لە شاری عامریەی الصمود، کارگەی (الصمود)وەک ناوەندێکی پیشەسازیی پێشەنگ لە بواری بەرهەمهێنانی بۆری و پارچەیی ئاسن دامەزراوە. ئێمە سوود لە نوێترین هێڵەکانی بەرهەمهێنان وەردەگرین بۆ دابینکردنی بەرهەمی کوالیتی بەرز کە وەڵامدەرەوەی پێداویستییەکانی بازاڕی ناوخۆیی و نێودەوڵەتی بێت، ئەمەش بە پابەندبوونی تەواو بە بەرزترین ستانداردەکانی ئەندازیاری و کوالیتی.",
    sm_vision:"دیدگای ئێمە",
    sm_vision_p:"ئامانجمان ئەوەیە ببینە یەکەم پێشەنگی ناوچەیی لە پیشەسازیی بۆری و پڕۆفیلی ئاسندا، و بەشداربین لە بنیاتنانی داهاتوویەکی تەلارسازی و پیشەسازیی بەهێز، ئەویش لە ڕێگەی پێشکەشکردنی بەرهەمانێک کە کۆکەرەوەی توندوتۆڵییەکی بێوێنە و وردکارییەکی ئەندازیاریی بێسنوور بن.",
    sm_mission:"پەیامی ئێمە",
    sm_mission_p:"پابەندیی ئێمە لە کارگەی الصمود بریتییە لە دابینکردنی چارەسەری پۆڵاینی کوالیتی بەرز کە لەگەڵ ستانداردە جیهانییەکاندا یەکبگرێتەوە. جەخت دەکەینەوە سەر داهێنان لە دروستکردن و نەرمی نواندن لە بەرهەمهێناندا بۆ پڕکردنەوەی سەرجەم پێداویستییەکانی پڕۆژە بیناسازی و پیشەسازییەکان بەوپەڕی وردی و متمانەپێکراوییەوە.",
    corvlaue:"بەها بنەڕەتییەکانمان",
    cor1:".توندوتۆڵیی بەرهەم لە سەختترین بارودۆخدا : خۆڕاگری ",
    cor2:" وردکاری:پابەندبوونی تەواو بە پێوانە و تایبەتمەندییە تەکنیکییەکان.",
    cor3:"   هاوبەشی: ئێمە لە هەر پڕۆژەیەکدا، هاوبەشی سەرکەوتنی کڕیارانمانین.",
    cor4:`هەوڵی بەردەوام بۆ نوێکردنەوەی هێڵەکانی بەرهەمهێنان و تەکنەلۆژیای دروستکردن دەدەین.`,
    qua:"کوالیتی و ستانداردە تەکنیکییەکان",
    qua_p:"لە کارگەی الصمود، کوالیتی تەنها دروشم نییە، بەڵکو پرۆسەیەکی گشتگیرە کە لە هەڵبژاردنی کەرەستەی خاوەوە (ڕۆڵە ئاسنەکان) دەست پێ دەکات و بە تاقیکردنەوەی بەرهەمی کۆتایی دەگاتە ئەنجام. ئێمە پابەندین بە بەرزترین ستانداردەکانی پیشەسازی بۆ دەستەبەرکردنی وردیی ڕەهەندەکان و جێگیریی ئەستووری (سمك) لە هەر پارچەیەکدا کە لە کارگەکەمانەوە بەرهەم دەهێنرێت.",
    comit:"پابەندبوونمان بە ستانداردەکان",
    comit_p:`o	
 پێوەرە ستانداردەکانی عێراق (IQS): سەرجەم بەرهەمەکانمان لە بۆری و پڕۆفیلی ئاسن بە شێوەیەک بەرهەم دەهێنرێن کە هاوتا و گونجاو بن لەگەڵ پێوەرە ستانداردە پەسەندکراوەکانی بۆ جۆریەتی و خۆڕاگری.
`,
    chs:"بەشی بۆرییە بازنەییەکان  ",
    dimen:"وردەکاریی قەبارە و ئەستووری :",
    or:"مەودای گشتی",
    or1:"لە ١٥.٨٨ ملم بۆ ٢١٩ ملم",
    sm:"قەبارە بچووکەکان  ",
    sm1:"(١٥.٨٨ - ٥٠.٨ ملم): ئەستوورییان لە ٠.٦٠ ملیمەوە دەست پێ دەکات",
    md:"قەبارە مامناوەندەکان  ",
    md1:"(١٠١ - ١١٤ ملم): ئەستوورییان لە ١.٥٠ ملیمەوە دەست پێ دەکات",
    lg:"قەبارە گەورەکان ",
    lg1:"(تا ٢١٩ ملم): ئەستوورییان لە ٢.٥٠ ملیمەوە دەست پێ دەکات",
    shs:"بەشی بۆڕی چوارگۆشەکان  ",
    or2:"لە ١٥×١٥ ملم بۆ ١٧٥×١٧٥ ملم",
    sm2:"(١٥×١٥ - ٤٠×٤٠ ملم): ئەستووری لە ٠.٦٠ ملمەوە دەست پێ دەکات",
    md2:"(٩٠×٩٠ - ١٠٠×١٠٠ ملم): ئەستووری لە ١.٥٠ ملمەوە دەست پێ دەکات",
    lg2:"(تا ١٧٥×١٧٥ ملم): ئەستووری لە ٢.٥٠ ملمەوە دەست پێ دەکات",
    rhs:"بەشی بۆڕی لاکێشەییەکان ",
    or3:"لە ١٠×١٥ ملم بۆ ١٥٠×٢٠٠ ملم",
    sm3:"(١٠×١٥ - ٣٠×٥٠ ملم): ئەستووری لە ٠.٦٠ ملمەوە دەست پێ دەکات",
    md3:"(٥٠×١٠٠ - ٧٥×١٥٠ ملم): ئەستووری لە ١.٥٠ ملمەوە دەست پێ دەکات",
    lg3:"(تا ١٥٠×٢٠٠ ملم): ئەستووری لە ٢.٥٠ ملمەوە دەست پێ دەکات",
    cs:"درێژیی ڕاسپێردراو و داواکارییە تایبەتەکان  ",
    sl:"(٣ مەتر تا ١٢ مەتر) وە درێژیی ستاندارد ٦ مەترە.",
    cl:"درێژیی ڕاسپێردراو: توانای بەرهەمهێنان بەپێی ویستی کڕیار لە ٣ مەترەوە تا ١٢ مەتر",
    product:"بوارەکانی بەکارهێنانی بەرهەمەکان ",
    product_p:"بۆری و پرۆفیلەکانی کارگەی الصمود بەهۆی وردی و توندوتۆڵییانەوە لە چەندین بواری جیاوازدا بەکاردێن، ئەمەش وای کردووە ببنە باشترین هەڵبژاردە بۆ کەرتە پیشەسازی و بیناسازییەکان، لەوانە:",
    pro1:"بیناسازی و ئاوەدانکردنەوە: دروستکردنی دەرگا، پەنجەرە، و پەیکەرە ئاسنینەکان بۆ باڵەخانە و کۆگاکان.",
    pro2:"پیشەسازییە کانزاییەکان: شێوەپێدانی پەیکەرە کانزاییە ئاڵۆزەکان و پلاتفۆرمەکان.",
    pro3:"پیشەسازیی مۆبیلیات: دروستکردنی چوارچێوە کانزاییەکان بۆ مۆبیلیاتی مۆدێرنی ماڵ و ئۆفیس.",
    pro4:"کەرتی کشتوکاڵی: دیزاینکردنی سیستەمەکانی ئاودێری و ڕەشێنەری تەوەرەیی، و بنیاتنانی خانووە پلاستیکییەکان.",
    pro5:"ژێرخان: ئەندازیاریی بەربەستەکان، پەرژینی ئەمنی، و ستوونی ڕووناکی.",
    sm_top_header1: "کارگەی الصمود بۆ بەرهەم هێنانی بۆری و پڕۆفایلی پۆڵا",
    sm_add_value:"عێراق، پارێزگای ئەنبار، عامرییەی فەللوجە، کۆمەڵگەی پیشەسازی صمود",

    "rs_slogan": "ڕاو ستێل: پێشەنگ لە بەرهەمهێنانی پلێتی گەلفەنایز و پلێتی ڕەنگی لەسەر ئاستی عێراق و کوردستان",
    "rs_about_title": "دەربارەی ئێمە",
    "rs_about_desc1": "کۆمپانیای ڕاو ستێل (Raw Steel) پڕۆژەیەکی پیشەسازی ستراتیژی و بێوێنەیە لەسەر ئاستی عێراق و هەرێمی کوردستان، کە تایبەتە بە پیشەسازی بۆیەکردن، ڕەنگکردن و گەلڤانایزکردنی پلێت و ڕۆلەی ئاسن و پۆڵاییەکان. کارگەکەمان لە پارێزگای هەولێر لەسەر ڕووبەری 84,000 مەتری چوارگۆشە بنیات دەنرێ، کە زیاتر لە 32%ی بۆ بۆشایی سەوزایی تەرخانکراوە بەمەبەستی پاراستنی ژینگە.",
    "rs_about_desc2": "ئێمە دەمانەوێت بە بەکارهێنانی نوێترین تەکنەلۆژیای جیهانی و هێڵی بەرهەمهێنانی پێشکەوتوو، کار بکەین بۆ دابینکردنی بەرهەمی کوالیتی بەرز کە ڕکابەری بەرهەمە جیهانییەکان بکات. پڕۆژەکەمان پاڵپشتێکی بەهێزی کەرتی گشتی و تایبەت دەبێ و ڕۆڵێکی سەرەکی دەگێڕێت لە کەمکردنەوەی هاوردەکردنی دەرەکی و ڕەخساندنی دەرفەتی کاری ڕاستەوخۆ و ناڕاستەوخۆ بۆ گەنجانی وڵاتەکەمان.",
    "rs_vision_title": "دیدگا",
    "rs_vision_desc": "بوون بە گەورەترین و متمانەپێکراوترین سەرچاوەی دابینکردنی رۆڵی گەلفەنایز و ڕەنگکراو لە تەواوی عێراق و ڕۆژهەڵاتی ناوەڕاست.",
    "rs_mission_title": "پەیام",
    "rs_mission_desc": "پێشکەشکردنی بەرهەمی پۆڵایی بەرزترین ستانداردی جیهانی کە بەرگەی گۆڕانکاریەکانی کەشوهەوا و ژەنگ بگرێت، بە نرخێکی گونجاو و کێبڕکێکار، لەگەڵ پابەندبوون بە بەرپرسیارێتی کۆمەڵایەتی و ژینگەیی.",
    "rs_products_title": "توانای بەرهەمهێنان و بەرهەمەکانمان",
    "rs_products_desc": "پڕۆژەی کارگەکەمان وابڕیارە بە توانایەکی بەرهەمهێنانی گەورە کار بکات کە بگاتە 20,000 تەن لە مانگێکدا، و بەرهەمە سەرەکییەکانمان بریتی دەبن لە:",
    "rs_prod1_title": "رۆلی ئاسنی ڕەنگکراو",
    "rs_prod1_desc": "بە توانای 8,000 تەن لە مانگێکدا، بە بەکارهێنانی بۆیەی کوالیتی بەرز و دژە ژەنگ بەپێی داواکاری و ڕەنگە جیاوازەکانی بازاڕ.",
    "rs_prod2_title": "رۆلی کانزایی گەلڤانایزکراو",
    "rs_prod2_desc": "بە توانای 12,000 تەن لە مانگێکدا، کە بە زینک یان کرۆم دادەپۆشرێن بۆ بەرگریکردن لە شێ، باران و داخوران و درێژکردنەوەی تەمەنی پۆڵا.",
    "rs_target_sectors_title": "ئەو سێکتەرانەی سوود لە بەرهەمەکانمان دەبینن:",
    "rs_sector1": "کارگەکانی بەرهەمهێنانی سەندویچ پانێڵ.",
    "rs_sector2": "کارگەکانی دروستکردنی تانکی ئاو و عەموودی کارەبا و تاوەرەکانی پەیوەندی.",
    "rs_sector3": "پیشەسازییەکانی دروستکردنی کەلوپەلی ناوماڵ و کارەبایی (سەلاجە، بەفرگر، جلشۆر، مێز و ڕەفە).",
    "rs_sector4": "کۆمپانیاکانی بیناسازی و دروستکردنی چوارچێوە و پێکهاتە ئاسنییەکان.",
    "rs_process_title": "قۆناغەکانی بەرهەمهێنان",
    "rs_process_desc": "ئێمە بڕیاروایە سیستەمێکی ڕێکخراو و بەردەوام (24 کاتژمێری) پەیڕەو بکەین لە ڕێگەی سێ شەفتی کارکردنەوە:",
    "rs_step1_title": "کڕینی کەرەستەی خاو",
    "rs_step1_desc": "هاوردەکردنی لولە پۆڵاییە ڕەشەکان لە باشترین سەرچاوە جیهانییەکان (وەک چین).",
    "rs_step2_title": "کردنەوەی ڕولەکان",
    "rs_step2_desc": "بەستنەوەی لولەکان بە شێوەیەکی بەردەوام بۆ نەپچڕانی هێڵی بەرهەم.",
    "rs_step3_title": "پاککردنەوە",
    "rs_step3_desc": "شتن و پاککردنەوەی پۆڵاکە لە شۆک و پاشماوەکان بە فۆسفات و شامپۆی تایبەت.",
    "rs_step4_title": "گەرمکردن",
    "rs_step4_desc": "ئامادەکردنی کانزاکە بۆ هەڵمژینی ڕەنگ یان زینک.",
    "rs_step5_title": "ڕەنگکردن یان گەلڤانایزکردن",
    "rs_step5_desc": "داپۆشینی ڕووی پۆڵاکە.",
    "rs_step6_title": "وشککردنەوە",
    "rs_step6_desc": "بەکارهێنانی فڕنی پێشکەوتوو بۆ وشککردنەوەی خێرا.",
    "rs_step7_title": "پێچانەوە و پێچان",
    "rs_step7_desc": "ئامادەکردنی کۆتایی بۆ کۆگا و بازاڕ.",
    "rs_env_title": "پابەندبوونی ژینگەیی و کۆمەڵایەتی",
    "rs_env_sub1": "پاراستنی ژینگە",
    "rs_env_desc1": "کارگەکەمان خاوەنی یەکەی چارەسەرکردنی ئاوی بەکارهاتوو و فلتەری پێشکەوتوو دەبێت بۆ ڕێگریکردن لە دەردانی غازی زیانبەخش.",
    "rs_env_sub2": "ڕەخساندنی هەلی کار",
    "rs_env_desc2": "پڕۆژەکە لە قۆناغی جێبەجێکردنیدا زیاتر لە 750 کارمەند و کراکار و لە قۆناغی کارپێکردنیدا زیاتر لە 80 کارمەندی هەمیشەیی لە خۆ دەگرێت.",
    "rs_swot_title": "خاڵە بەهێزەکانمان",
    "rs_swot1_title": "پڕۆژەی ناوازە",
    "rs_swot1_desc": "یەکەمین و گەورەترین کارگەی لەم شێوازە دەبێت لەسەر ئاستی ناوچەکە.",
    "rs_swot2_title": "کوالیتی جیهانی",
    "rs_swot2_desc": "کێبڕکێی ڕاستەوخۆی بەرهەمە هاوردەکراوەکانی تورکیا و ئێران دەکەین.",
    "rs_swot3_title": "پەرەپێدانی بەردەوام",
    "rs_swot3_desc": "ستافەکەمان بەردەوام لە خولی ڕاهێنانی چڕدا دەبن بۆ بەکارهێنانی نوێترین تەکنەلۆژیا.",
    "rs_address_value": "عێراق، هەرێمی کوردستان، پارێزگای هەولێر."
  },

};
export default kur;